import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { Card, CardContent } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import CardMedia from '@material-ui/core/CardMedia';
import Loginlogo from '../../assets/Login_logo.png';
import ButtonComp from '../../components/button/index';
import '../../components/accordin/styles.css';

const useStyles = makeStyles((theme) => ({
    logo: {
        width: '100%',
    },
    media: {
        width: '80%',
        paddingTop: '3%',
        paddingBottom: '2%',
    },
    container: {
        padding: '10px 20px ',
        color: '#000000',
        fontFamily: 'rubik',
        fontSize: '1rem',
    },
    fullWidth: {
        color: '#959595',
    },
    body: {
        fontFamily: 'rubik',
    },
    address: {
        color: '#474646',
        fontFamily: 'rubik',
    },
    date: {
        fontFamily: 'rubik',
        fontWeight: 'bold',
        color: '#504d4d',
    },
}));

export default function EngagementLetter() {
    const classes = useStyles();

    return (      
        
        <form>
        <Card className="clientcard">
            <CardContent className="client-heading">
                <Typography variant="h5">Engagement Letter</Typography>
            </CardContent>
            <CardContent>
        <Grid container spacing={3} className={classes.container}>
            <Grid item xs={3}>
                    <CardMedia className={classes.media}>
                            <img src={Loginlogo} alt="logo" className={classes.logo} />
                        </CardMedia>
            </Grid>
            <Grid item xs={6} />
            <Grid item xs={3} >
                <div>
                    <Typography variant="6" className={classes.fullWidth}> 
                                No 72/1, First floor, 
                                Jnanodaya School Road, 
                                Shankarapark, 
                                Shankarpuram, 
                                Bangalore 560004.
                    </Typography>
                </div>
            </Grid>
            <Grid item xs={12} >
                <div>
                    <span className={classes.date}>
                                05-04-2021
                    </span>
                </div><br/>
                <div>
                    <span className={classes.date}>
                                234567890
                    </span>
                </div>
            </Grid>
            <Grid item xs={3} >
                <div>
                    <Typography>
                        <span className={classes.date}>
                                    Maveric
                        </span><br/>
                    </Typography>
                    <Typography className={classes.address}>
                                Anchorage#, 100, 
                                Richmond Rd, Bengaluru, 
                                Karnataka 560025.
                    </Typography> 
                </div>
            </Grid>
            <Grid item xs={12} >
                <div>
                    <Typography className={classes.body}>
                                Greetings..!!
                    </Typography>
                </div><br/>
                <div>
                    <Typography className={classes.body}>
                        <span className={classes.date}>Re</span>: <u>Lorem ipsum dolor</u>
                    </Typography>
                </div><br/>
                <div>
                <Typography paragraph className={classes.body}>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam mollis dapibus sollicitudin. Fusce molestie varius libero, nec venenatis libero dignissim et. Aenean eu tempus justo, eu lacinia nunc. Etiam vehicula sed mauris et euismod. Fusce at mauris molestie, feugiat lorem et, tempus arcu. Cras vitae tellus pellentesque, accumsan mi ac, auctor orci. Aenean nec est ut felis facilisis lobortis in nec ligula. Duis non vestibulum arcu. Praesent semper dolor in condimentum fringilla. Suspendisse accumsan turpis nec dignissim imperdiet. Praesent nec faucibus quam. Sed elementum elementum est non congue.
                </Typography>
                </div> 
            </Grid>
            </Grid>
            </CardContent>
        </Card>
             <ButtonComp type="submit" className="intermediarybutn" title="Approve with OTP verification" />
        </form>

    );
}
